/**
 * QA Management Helper Functions
 */

export const getProgramSchoolClass = (school?: string): string => {
  if (!school) return 'school-default';
  const schoolLower = school.toLowerCase();
  if (schoolLower === 'seas') return 'school-seas';
  if (schoolLower === 'gsas') return 'school-gsas';
  if (schoolLower === 'cc') return 'school-cc';
  if (schoolLower === 'gs') return 'school-gs';
  if (schoolLower === 'barnard college' || schoolLower.includes('barnard')) return 'school-barnard';
  if (schoolLower === 'journalism') return 'school-journalism';
  if (schoolLower === 'cvn') return 'school-cvn';
  return 'school-default';
};

export const getVisaTagClass = (visa: string): string => {
  const visaLower = visa.toLowerCase();
  if (visaLower.includes('apply')) return 'visa-apply-to-all';
  if (visaLower.includes('non-visa')) return 'visa-non-visa-holder';
  if (visaLower.includes('visa')) return 'visa-holder';
  return 'visa-default';
};

export const getStatusTagClass = (status: string): string => {
  const statusLower = status.toLowerCase();
  if (statusLower.includes('apply')) return 'status-apply-to-all';
  if (statusLower === 'current') return 'status-current';
  if (statusLower === 'applicant') return 'status-applicant';
  if (statusLower === 'alumni') return 'status-alumni';
  return 'status-default';
};

export const capitalizeSchool = (school: string): string => {
  return school.toUpperCase();
};
